import * as React from "react";
import {
  ActivityFragment,
  CampaignMinimalFragment,
  CompanyMinimalFragment
} from "../../../graphql/fragments";
import useTranslations from "../../../hooks/useTranslations";
import { timeAgoLabel } from "../../../utils/timeAgo";
import { BuildingIcon } from "../../icons";
import { Link } from "../../wombat-ui";
import { Span } from "../../wombat-ui/components/Typography";
import Activity from "../ActivityPlate";

type CampaignCreatedActivity = ActivityFragment & {
  recipient: CompanyMinimalFragment;
  trackable: CampaignMinimalFragment;
};

export function isCampaignCreatedActivity(
  q: ActivityFragment
): q is CampaignCreatedActivity {
  return q.key === "campaign.created";
}

interface CampaignCreatedActivityProps {
  activity: CampaignCreatedActivity;
}

export const CampaignCreatedActivity: React.FC<CampaignCreatedActivityProps> = ({
  activity,
}) => {
  const t = useTranslations();

  return (
    <Activity
      activity={activity}
      id="campaignCreatedActivity"
      visual={<BuildingIcon iconClassName="w-10 h-10 text-accent-500" />}
    >
      <Span className="text-sm">
        {t("activity.labels.campaignCreated", {
          campaign: (
            <Link
              to={`/campaigns/${activity.trackable.slug}`}
              key={activity.id}
            >
              {t("activity.objects.campaign")}
            </Link>
          ),
        })}
      </Span>
    </Activity>
  );
};
